<template>
    <div class="admin-currency-list">
        <div class="slider-list-item slider-list-item-add" v-if="allow_add" @click="onNewClick" v-loading="processing">
            <div class="slider-list-item-container">
                <i class="el-icon-plus"></i> 
                <div>Add a new Currency</div> 
            </div>
        </div>
        <AdminCurrencyListItem  v-for="currency in currencies" :key="currency.id" :currency="currency" :selectedId="selectedData" :reload="loadData" />
        <AdminCurrencyNew :show="showNew" :onClose="onNewClose" />
    </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import AdminCurrencyListItem from "./AdminCurrencyListItem";
import AdminCurrencyNew from "./AdminCurrencyNew";

export default {
    name: "AdminCurrencyList",
    components: {
        AdminCurrencyListItem,
        AdminCurrencyNew
    },
    data() {
        return {
            processing: false,
            showNew: false,
            selectedData: null,
            currencies: []
        };
    },
    mounted() {
        this.loadData();
    },
    computed: {
        ...mapState({
            adminPerms: state => state.adminPerms,
        }),
        showDetail() {
            if (this.selectedData) {
                return true;
            }
            return false;
        },
        allow_add(){
            if(this.adminPerms && this.adminPerms.currency && this.adminPerms.currency.length > 0 && this.adminPerms.currency[0].add_currency){
                return true;
            }
            return false
        }
    }, 
    methods: {
        ...mapActions(["request", "getError", "setCurrencies"]),

        onNewClick() {
            this.showNew = true;
        },
        onNewClose(reload = false) {
            this.showNew = false;
            if (reload == true) {
                this.setCurrencies();
            }
        },
        loadData() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `currencies`
            })
                .then(({ data = {} }) => {
                    ctrl.currencies = data.results;
                    ctrl.$forceUpdate();
                })
                .catch(err => {
                    ctrl.getError({
                        err
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>
<style scoped>
.slider-list-item {
    cursor: pointer;
    width: 100%;
    padding: 8px;
}

.slider-list-item-container {
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    background-color: #eee;
    height: 100%;
}

.slider-list-item-container:active {
    transform: scale(0.95);
}
.slider-list-item-add .slider-list-item-container{
    align-items:center;
    align-content: center;
    justify-content: center;
    font-size: 18px;
    padding:  16px;
}

.permission-list {
    background-color: #eee;
}

.new-permission-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-permission-btn:hover {
    color: #fff;
    background-color: #00669a;
}

.new-permission-btn:active {
    color: #fff;
    background-color: #177CB0;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
</style>

<style >
.permission-list-item {
    cursor: pointer;
}
</style>